import { FETCH_FLEX_META_DATA_LABELS_REQUEST, FETCH_FLEX_META_DATA_LABELS_SUCCESS, FETCH_FLEX_META_DATA_LABELS_FAILURE } from "./FlexMetaDataTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";
import APIManager from "../../ApiManager/ApiManager";

export const fetchFlexMetaDataLabelsRequest = () => {
  return {
    type: FETCH_FLEX_META_DATA_LABELS_REQUEST
  };
};      

export const fetchFlexMetaDataLabelsSuccess = (labels) => {     
    return {
      type: FETCH_FLEX_META_DATA_LABELS_SUCCESS,
      payload: labels
    };
}   

export const fetchFlexMetaDataLabelsFailure = (error) => {     
    return {
      type: FETCH_FLEX_META_DATA_LABELS_FAILURE,
      payload: error
    };
}
export const fetchFlexMetaDataLabels = () => {
    return  async(dispatch) => {
      dispatch(fetchFlexMetaDataLabelsRequest());
      try {
        const portfolioId = sessionStorage.getItem("portfolioId");
        const response = await APIManager.getFlexMetaDataLabels(portfolioId);
        dispatch(fetchFlexMetaDataLabelsSuccess(response));
      } catch (error) {
        dispatch(fetchFlexMetaDataLabelsFailure(error));
      }
    };
};

export const postFlexMetaDataLabels = (portfolioId, payload) => { 
  return async (dispatch) => {
    dispatch(fetchFlexMetaDataLabelsRequest());   
    try {
      await APIManager.postFlexMetaDataLabels(portfolioId, payload);
      await dispatch(fetchFlexMetaDataLabels())
    } catch (error) {
      dispatch(fetchFlexMetaDataLabelsFailure(error));
    }   
  }
}

export const deleteFlexMetaDataLabel = (portfolioId, labelId) => { 
  return async (dispatch) => {
    dispatch(fetchFlexMetaDataLabelsRequest());
    try {
      await APIManager.deleteFlexMetaDataLabel(portfolioId, labelId);
      await dispatch(fetchFlexMetaDataLabels())
    } catch (error) {
      dispatch(fetchFlexMetaDataLabelsFailure(error));
    }
  }
}

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};

